<template>
  <div class="staff-boxs">
    <div class="top-bar com-model m-b-15">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index/staff/list' }">员工管理</el-breadcrumb-item>
        <el-breadcrumb-item>更换管理员</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="staffmanage">
      <div class="st-change-bar m-b-20">修改完成后，绑定的安全手机将会被修改！</div>
      <div class="item">
        <div class="label">验证码</div>
        <div class="value input-box">
          <input type="text" placeholder="请输入验证码" v-model="verifyCode" />
        </div>
        <div class="primary-btn"
             style="margin-left: 40px; padding: 0 40px;"
             :class="{'regyzmYfs':issend}"
             @click="getcode">
          {{yzmtxt}}
        </div>
      </div>
      <div class="item">
        <div class="label">选择新的管理员</div>
        <div class="value select-box">
          <el-select v-model="newHrId" placeholder="请选择">
            <el-option v-for="item in enableList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id" />
          </el-select>
        </div>
      </div>
      <div class="stepbtn" @click="changeAdm">完成</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        verifyCode: '',
        name: 123,
        rowslist: [],
        total: -1,
        tabindex: 0,
        enableList: [],
        newHrId: null,
        yzmtxt: '发送验证码',
        issend: false, // 是否发送验证码
      }
    },
    created() {
      this.getlist();
      this.axios.get('/wapi/company/getAdmin').then(res => {
        this.adminInfo = res.data;
      });
    },
    methods: {
      getcode() {
        if (this.issend) {
          return;
        }
        let url = '/wapi/company/getChangeAdminCode';
        this.axios.get(url).then(res => {
          if (res.success) {
            this.issend = true;
            this.yzmDjs();
          }
        });
      },
      getlist() {
        let url = '/wapi/hr/pageEnabled?pageNum=1&pageSize=100';
        this.axios.get(url).then(res => {
          this.enableList = res.rows;
        });
      },
      changeAdm() {
        if (!this.newHrId) {
          this.$message({
            type: 'warning',
            message: '请选择新的管理员'
          });
          return;
        }
        let url = `/wapi/company/changeAdmin?newHrId=${this.newHrId}&verifyCode=${this.verifyCode}`;
        this.axios.get(url).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.isreg = true;
          }
        });
      },
      yzmDjs() {
        let times = 60;
        this.yzmtxt = times + 's后重新发送';
        let interval = setInterval(() => {
          times--;
          if (times < 0) {
            clearInterval(interval);
            this.yzmtxt = "发送验证码";
            this.issend = false;
          } else {
            this.yzmtxt = times + 's后重新发送';
          }
        }, 1000);
      }
    }
  }
</script>
<style scoped lang="less">
  @import url('../../assets/less/base.less');
  @import "../../assets/css/staff";

  .com-model, .staffmanage {
    border-radius: 10px;

    .st-change-bar {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  }

  .top-bar {
    padding: 22px 24px;
    line-height: 30px;
  }

  .item {
    margin-left: 24px;
    margin-bottom: 16px;
    font-size: 16px;
    color: #333333;
    .flex;

    .label {
      width: 125px;
      display: flex;
      line-height: 40px;
      justify-content: flex-end;
      align-items: flex-start;
      margin-right: 24px;

      &.require {
        &::before {
          content: '*';
          color: #E91414;
          display: block;
          font-size: 18px;
          margin-right: 10px;
        }
      }
    }

    .primary-btn {
      height: 40px;
      line-height: 40px;
    }

    .value {
      .flex;
    }

    .input-box {
      height: 40px;
      border-radius: 4px;
      border: 1px solid #E6E6E6;
      background: transparent;
      width: 220px;;

      &.min {
        width: 128px;
      }
    }

    .select-box {
      height: 40px;
      width: 220px;

      .el-select {
        height: 40px;
      }
    }

    .one-input {
      width: 220px;
    }
  }

  .staffmanage .st-change-item .regyzmYfs {
    background: #ccc;
    border-color: #ccc;
    color: #fff;

    &:active {
      background-color: #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// changeadm.vue?20c7d4b1